import React from 'react';

export function Footer() {
  return (
    <footer className="text-center">
      <p><strong>Hobbio</strong></p>
      <p><a href="https://docs.google.com/presentation/d/1xab2K1LAruWVBG2gWt4b4GjfefIgbTD3cRu09vx9Y64/edit?usp=sharing">Final Presentation</a> · <a href="https://miro.com/app/board/uXjVMEz2DeA=/?share_link_id=734591418960"> Miro Board</a> · <a href="https://docs.google.com/document/d/1p1Z9n8ldaXU8eYtuWxacbKAAbAUiJANhK1zLEXcNhO0/edit?usp=sharing">Hand-off Documents</a></p>
      <p>&copy; Hobbio 2023 University Of Washington</p>
      <p>Note: this project will be going open source as of June 4, 2023</p>
    </footer>
  )
}